import { render, staticRenderFns } from "./ClientBot.vue?vue&type=template&id=9d37fb44"
import script from "./ClientBot.vue?vue&type=script&lang=js"
export * from "./ClientBot.vue?vue&type=script&lang=js"
import style0 from "./ClientBot.vue?vue&type=style&index=0&id=9d37fb44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports